import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Lock, Store } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { BrandPhotos } from "@/components/video/BrandPhotos";

const Locked = () => (
  <div className="mt-5 flex flex-col gap-4 rounded-2xl bg-[#F5F5F7] p-5 sm:flex-row sm:items-center sm:justify-between" data-testid="brand-locked">
    <p className="flex items-center gap-2 text-sm text-[#52525b]"><Lock className="h-4 w-4 text-[#0066FF]" /> Nome dell'attività disponibile con il piano Pro (19€ al mese).</p>
    <Link to="/tool/mimis-video#prezzo" className="btn-blu h-11 px-5 text-sm" data-testid="brand-upgrade-link">Passa a Pro</Link>
  </div>
);

const NameForm = () => {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/account/brand").then((r) => setName(r?.data?.nome_attivita ?? "")).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/account/brand", { nome_attivita: name });
      toast.success("Nome salvato");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="mt-6 flex flex-col gap-3 sm:flex-row">
      <input value={name} onChange={(e) => setName(e.target.value.slice(0, 40))} placeholder="Es: Pizzeria da Mario" data-testid="brand-name-input"
        className="h-12 flex-1 rounded-full border border-[#e7e7ea] bg-[#F5F5F7] px-5 text-base outline-none transition-[border-color,background-color] focus:border-[#0066FF] focus:bg-white" />
      <button type="submit" disabled={busy} className="btn-blu h-12 px-6 text-sm" data-testid="brand-name-save">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva nome"}</button>
    </form>
  );
};

export const BrandKit = ({ pro }) => (
  <section id="brand" className="card-soft mt-6 p-7 hover:translate-y-0 sm:p-9" data-testid="brand-kit">
    <p className="flex items-center gap-2 font-display text-xl font-bold"><Store className="h-5 w-5 text-[#0066FF]" /> La tua attività nei video</p>
    <p className="mt-2 text-sm text-[#52525b]">Il nome compare alla fine di ogni video al posto di MIMIS. Le foto prendono il posto di 3 immagini create dall'AI.</p>
    {pro ? <NameForm /> : <Locked />}
    <p className="mt-7 text-sm font-semibold">Le tue 3 foto</p>
    <div className="mt-3"><BrandPhotos tid="brand" /></div>
  </section>
);
